/**
 * Jours fériés — RG-FER-001 (calculés), RG-FER-002 (table des fériés flottants
 * de l'opérateur), RG-FER-003 (fériés tombant un week-end).
 *
 * La v1 calculait Pâques par l'algorithme du nombre d'or/épacte (avec
 * corrections 1900-1999) ; la v2 utilise Butcher-Meeus, exact sur tout le
 * calendrier grégorien, avec tests croisés 1990-2100 (cf. spec associée ;
 * le croisement contre l'implémentation v1 sera rejoué dès livraison du
 * code source Delphi — GM-001).
 */
import { ajouterJours, dateInt, jourSemaineIso, } from './date-civile.js';
/** Dimanche de Pâques (Butcher-Meeus, calendrier grégorien). */
export function paques(an) {
    const a = an % 19;
    const b = Math.trunc(an / 100);
    const c = an % 100;
    const d = Math.trunc(b / 4);
    const e = b % 4;
    const f = Math.trunc((b + 8) / 25);
    const g = Math.trunc((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.trunc(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.trunc((a + 11 * h + 22 * l) / 451);
    const mois = Math.trunc((h + l - 7 * m + 114) / 31);
    const jour = ((h + l - 7 * m + 114) % 31) + 1;
    return { an, mois, jour };
}
/**
 * RG-FER-001 — fériés légaux belges d'une année :
 * 01/01, 01/05, 21/07, 15/08, 01/11, 11/11, 25/12,
 * lundi de Pâques, Ascension (lundi de Pâques + 38 j), lundi de Pentecôte (Ascension + 11 j).
 */
export function feriesLegaux(an) {
    const lundiPaques = ajouterJours(paques(an), 1);
    const ascension = ajouterJours(lundiPaques, 38);
    const lundiPentecote = ajouterJours(ascension, 11);
    return [
        { an, mois: 1, jour: 1 },
        lundiPaques,
        { an, mois: 5, jour: 1 },
        ascension,
        lundiPentecote,
        { an, mois: 7, jour: 21 },
        { an, mois: 8, jour: 15 },
        { an, mois: 11, jour: 1 },
        { an, mois: 11, jour: 11 },
        { an, mois: 12, jour: 25 },
    ];
}
export function estFerieCalcule(d) {
    const di = dateInt(d);
    return feriesLegaux(d.an).some((f) => dateInt(f) === di);
}
/**
 * RG-FER-002 — le moteur teste d'abord les fériés calculés, PUIS la table
 * `JoursFeries` de l'opérateur (fériés flottants : reports, fermetures…).
 *
 * @param tableFeriesFlottants dates int AAAAMMJJ issues de la table opérateur.
 */
export function estFerie(d, tableFeriesFlottants) {
    return estFerieCalcule(d) || tableFeriesFlottants.has(dateInt(d));
}
/**
 * RG-FER-003 — un férié tombant un SAMEDI ou un DIMANCHE n'est pas traité
 * comme férié par le moteur (récupéré un autre jour via la table).
 * Les règles du moteur (RG-ASS-060, RG-REP-030, RG-PLA-004) testent donc
 * « férié EN SEMAINE » : ce prédicat est le seul que la boucle quotidienne
 * doit utiliser.
 */
export function estFerieEnSemaine(d, tableFeriesFlottants) {
    return jourSemaineIso(d) <= 5 && estFerie(d, tableFeriesFlottants);
}
//# sourceMappingURL=jours-feries.js.map